import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import 'react-notifications/lib/notifications.css';
import {NotificationManager} from 'react-notifications';
import Dialog from "./Dialog";

const OrganismeRib = (props) =>
{
    const [rib, setRib] = useState(null);
    const [id_organisme, setId_organisme] = useState('');
    const [iban, setIban] = useState('');
    const [bic, setBic] = useState('');
    
    // état pour Dialog personnalisé
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');

    const green = '#59B44A';
    const purple = '#6571FE';
    
    async function mount()
    {
        if (props.user && props.user.id_organisme)
        {
            setId_organisme(String(props.user.id_organisme));
            var params = {
                'get': true,
                'id_organisme': props.user.id_organisme
            };
            await axios.post('/api/organismes_rib.php', qs.stringify(params))
            .then((res) => {
                console.log(res.data)
                if (res && res.data) {
                    setRib(res.data);
                    setIban(res.data.iban || '');
                    setBic(res.data.bic || '');
                }
                else {
                    setRib(null);
                    clearForm();
                }
            })
            .catch((err) => {
                console.warn(err)
            })
        }
    }

    useEffect(() => {
        mount();
    }, [props.user]);

    const clearForm = () => {
        setIban('');
        setBic('');
    };

    const formatIban = () => {
        // Supprime les espaces et met en majuscules
        const ibanValue = iban.replace(/\s/g, '').toUpperCase();
        // Ajoute un espace tous les 4 caractères
        const formatted = ibanValue.replace(/(.{4})/g, '$1 ').trim();
        setIban(formatted);
    };

    const formatBic = () => {
        // Met en majuscules
        setBic(bic.toUpperCase());
    };

    const updateRib = async () => {
        if (!iban || !iban.trim()) {
            setDialogMessage("Le champ « IBAN » est requis.");
            setDialogOpen(true);
            return;
        }
        try {
            const params = {
                update: true,
                id_organisme: id_organisme,
                iban: iban,
                bic: bic
            };
            const res = await axios.post('/api/organismes_rib.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success("RIB mis à jour avec succès.", '', 2000);
                await mount();
            } else {
                const msg = res && res.data && res.data.message ? res.data.message : 'Erreur mise à jour RIB';
                NotificationManager.error(msg, '', 4000);
                console.warn('Erreur mise à jour RIB', res && res.data ? res.data : res);
            }
        } catch (e) {
            NotificationManager.error("Erreur lors de la requête de mise à jour.", '', 4000);
            console.error(e);
        }
    };

	return (
        <div className='shadow-md' style={{textAlign: 'left',  borderRadius: 3, padding: 20, margin: 1, backgroundColor: 'white'}}>
            <div style={{textAlign: 'center'}}>
                <p style={{fontWeight: 'bold', fontSize: 16, marginBottom: 20, color: purple}}>Coordonnées bancaires</p>
            </div>

            <div style={{display: 'flex', flexWrap: 'wrap', gap: 12}}>
                <div style={{flex: '1 1 48%', minWidth: 250}}>
                    <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>IBAN</label>
                    <input value={iban} onChange={e => setIban(e.target.value)} onBlur={formatIban} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ex: FR1420041010050500013M02606" />
                </div>

                <div style={{flex: '1 1 48%', minWidth: 250}}>
                    <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>BIC</label>
                    <input value={bic} onChange={e => setBic(e.target.value)} onBlur={formatBic} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ex: BNPAFRPP" />
                </div>
            </div>

            <div style={{display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20}}>
                <button
                    onClick={updateRib}
                    style={{padding: '8px 12px', borderRadius: 4, backgroundColor: green, color: 'white', border: 'none', cursor: 'pointer'}}
                >
                    Mettre à jour
                </button>
            </div>
        </div>
	);
}

export default OrganismeRib;
